export const rescaleAllIcon = {
  svg: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.2125 5.8502H7.25C6.97386 5.8502 6.75 6.07405 6.75 6.3502V10.7502C6.75 11.0263 6.97386 11.2502 7.25 11.2502H13C13.2761 11.2502 13.5 11.0263 13.5 10.7502V6.3502C13.5 6.07405 13.2761 5.8502 13 5.8502H12.0375M8.2125 5.8502H10.125H12.0375M8.2125 5.8502V4.61269C8.2125 3.55645 9.06876 2.7002 10.125 2.7002V2.7002C11.1812 2.7002 12.0375 3.55645 12.0375 4.61269V5.8502" stroke-width="1.5"/>
<path d="M3.59687 2.25V13.9C3.59687 14.1761 3.82073 14.4 4.09687 14.4H15.7469M3.59687 2.25H1.79688M3.59687 2.25H5.39687M15.7469 14.4V12.6M15.7469 14.4V16.2" stroke-width="1.5"/>
</svg>
`,
  name: 'rescaleAll',
};

export const rescaleCurrentFrameIcon = {
  svg: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.59687 2.25V13.9C3.59687 14.1761 3.82073 14.4 4.09687 14.4H15.7469M3.59687 2.25H1.79688M3.59687 2.25H5.39687M15.7469 14.4V12.6M15.7469 14.4V16.2" stroke-width="1.5"/>
<path d="M9 5.4001L9.94645 4.45365C10.2614 4.13867 10.8 4.36175 10.8 4.8072V10.3501" stroke-width="1.5" stroke-linecap="round"/>
</svg>`,
  name: 'rescaleCurrentFrame',
};
